export const CLIENT_SYSTEM = {
  OSM: 'osm',
}

export const singularSystemMapLabel = {
  osm: 'OS-m',
}
